/* eslint-disable */

import { Tabs, TabsList, TabsTrigger, TabsContent } from '../../Components/ui/tabs'
import Summary from './Summary'
import Assets from './Assets'
import Liabilities from './Liabilities'

const TABS = [
  {
    label: 'Summary',
    value: 'summary',
  },
  {
    label: 'Asset',
    value: 'asset',
  },
  {
    label: 'Liabilities',
    value: 'liabilities',
  },
]

const FamilyDashboard = () => {
  return (
    <div className='mx-auto min-h-screen max-w-[1128px] bg-gray-50 font-IBM lg:bg-white'>
      <Tabs defaultValue='summary' className='mb-2 w-full pb-6'>
        <div className='px-4 pt-3 lg:px-0'>
          <TabsList className='mx-auto grid h-12 w-full max-w-[520px] grid-cols-3 rounded-full lg:mx-0'>
            {TABS.map((tab) => (
              <TabsTrigger
                key={tab.value}
                value={tab.value}
                className='h-10 px-2 text-sm leading-5 md:px-4'
              >
                {tab.label}
              </TabsTrigger>
            ))}
          </TabsList>
        </div>
        <TabsContent value='summary'>
          <Summary />
        </TabsContent>
        <TabsContent value='asset'>
          {' '}
          <Assets />{' '}
        </TabsContent>
        <TabsContent value='liabilities'>
          {' '}
          <Liabilities />{' '}
        </TabsContent>
      </Tabs>
    </div>
  )
}

export default FamilyDashboard
